import React from 'react';
import { addFormatAndQualityAutoIntoUrl } from 'utils/url';
import { ImageWithFallback } from 'common/components/image-with-fallback';
import { BannerImageProps } from '../types';
import { BannerImageStyles } from '../styles';

export const BannerImage: React.FC<BannerImageProps> = props => {
  const { cdnUrl, pictureUrl } = props;

  if (!cdnUrl) {
    return <img src={pictureUrl} className={BannerImageStyles} alt="Реклама" loading="lazy" />;
  }

  const formattedCdnUrl = addFormatAndQualityAutoIntoUrl(cdnUrl);

  return (
    <ImageWithFallback
      src={formattedCdnUrl}
      fallbackSrc={pictureUrl}
      className={BannerImageStyles}
      redisHash="banners-carousel"
    />
  );
};
